<template lang="pug">
  v-container.ma-0.pa-0
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card.elevation-0.pa-0(flat :width="getCardClass")
      v-card-title {{ $t('ratingStatisticPage.ratingStatisticPageTitle') }}
      v-card-text.pa-0
        v-row.ma-0
          v-col.text-md-start.pl-md-0(cols="3" md="1" xl="1")
            v-btn(fab icon)
              v-icon(color="teal" @click="onPrevButtonClick") fas fa-chevron-circle-left
          v-col.text-center.pt-6(cols="6" md="4" xl="4")
            v-menu(
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(v-bind="attrs" v-on="on" text) {{getMonth}}
              v-date-picker(
                v-model="selectedMonth"
                type="month"
                no-title
                prev-icon="fas fa-chevron-left"
                next-icon="fas fa-chevron-right"
                @change="onMonthChange"
              )
          v-col.text-end.text-md-start(cols="3" md="7" xl="7")
            v-btn(fab icon )
              v-icon(color="teal" @click="onNextButtonClick")  fas fa-chevron-circle-right
        v-tabs( v-model="tab" grow)
          v-tab.pa-0 {{ $t('ratingStatisticPage.overviewRatingStatistic') }}
          v-tab.pa-0 {{ $t('ratingStatisticPage.description') }}
        v-tabs-items(v-model="tab")
          v-tab-item.pt-3
            v-card.elevation-0.pa-0(v-if="ratingStatistic && !fetchInProgress")
              v-card-text.pa-0
                v-row.ma-0.mt-6
                  v-col.pa-0.text-center(cols="3")
                    v-icon(color="error" large ) fas fa-grimace
                  v-col.pa-0.text-center(cols="3")
                    v-icon(color="orange" large) fas fa-frown-open
                  v-col.pa-0.text-center(cols="3")
                    v-icon(color="primary" large) fas fa-smile
                  v-col.pa-0.text-center(cols="3")
                    v-icon(color="success" large) fas fa-grin-hearts
                v-row.ma-0
                  v-col.pa-0.subtitle-2.text-center(cols="3" v-for="(item,idx) in ratingStatistic.valueSummary" :key="idx") {{item.count}}x
                v-row.ma-0.subtitle-1.text-style.mt-6
                  v-col.pa-0.text-start(cols="8") {{ $t('ratingStatisticPage.meanTitle') }} / {{ $t('ratingStatisticPage.medianTitle') }} :
                  v-col.pa-0.text-end(cols="4") {{ratingStatistic.meanValue.toFixed(2)}} / {{ratingStatistic.medianValue.toFixed(2)}}
                v-row.ma-0.subtitle-1.text-style
                  v-col.pa-0.text-start.d(cols="10") {{ $t('ratingStatisticPage.ratingCount') }} / {{ $t('ratingStatisticPage.totalOffer') }} :
                  v-col.pa-0.text-end(cols="2") {{ratingStatistic.totalOfferReservationRatings}} / {{ratingStatistic.totalOfferReservations}}
                v-row.ma-0.subtitle-1.text-style.mb-6
                  v-col.pa-0.text-start(cols="10") {{ $t('ratingStatisticPage.percentCount') }} :
                  v-col.pa-0.text-end(cols="2") {{getValue(ratingStatistic.totalOfferReservationRatings,ratingStatistic.totalOfferReservations).toFixed(2)}} %

            v-skeleton-loader(v-else type="list-item@10" )
            v-card.elevation-0.pa-0(v-if="ratingStatistic && ratingStatistic.summaryByDay && ratingStatistic.summaryByDay.length > 0 && !fetchInProgress")
              v-card-title.pa-0
                v-row.ma-0
                  v-col.pa-0.text-end(cols="12")
                    v-btn.pa-0(text @click="onSaveReportClick" color="primary" :style="{ 'text-transform': 'lowercase' }") {{ $t('ratingStatisticPage.downloadReportButtonTitle') }}
              v-card-text.pa-0.overflow-y-auto(:style="{height:'45vh'}")
                v-list
                  v-row.ma-0.subtitle-1.text-start
                    v-col.pa-0.text-start(cols="6") {{ $t('ratingStatisticPage.dailyRatings') }}
                    v-col.pa-0.text-start(cols="3") {{ $t('ratingStatisticPage.meanTitle') }}
                    v-col.pa-0.text-start(cols="3") {{ $t('ratingStatisticPage.medianTitle') }}
                  v-divider
                  v-list-item.list-item-style(v-for="(item,idx) in ratingStatistic.summaryByDay[0]" :key="idx" :class="{ 'blue-grey lighten-5': idx % 2 !== 0 }" @click="onDateClick")
                    v-list-item-title.ma-0
                      v-list-item-content.ma-0
                        v-row.ma-0.text-start
                          v-col.text-start.pa-0(cols="6") {{getDate(item.date)}}
                          v-col.text-start.pa-0.pl-2(cols="3") {{parseFloat(item.meanValue).toFixed(2)}}
                          v-col.text-start.pa-0.pl-4(cols="3") {{parseFloat(item.medianValue).toFixed(2)}}
            v-skeleton-loader(v-else type="list-item@10" )
          v-tab-item.pt-3
            v-card.elevation-0.pa-0.pt-2(v-if="ratingStatisticsDetail && ratingStatisticsDetail.length > 0")
              v-card-text.pa-0
                v-list.pa-0.ma-0
                  v-list-item-group.ma-0(v-for="(i,index) in getFormattedDetailData" :key="index")
                    v-subheader.ma-0.pa-0 {{getFormattedDate(i[0].date)}}
                    v-list-item-content.pa-0.mt-2(v-for="(a,idx) in i"  :key="idx" )
                      v-row.ma-0
                        v-col.pa-0.pl-4.text-start.pt-1(cols="2")
                          v-icon.text-center(large  :color="getRatingColor(a.value)") {{getRatingValue(a.value)}}
                        v-col.pa-0(cols="10")
                          v-row.ma-0
                            v-col.pa-0.subtitle-1(cols="10") {{a.boarder.firstName}} {{a.boarder.familyName}}
                          v-row.ma-0
                            v-col.pa-0.text-start(cols="12" :style="{ color: getNoteColor(a.note) === 'grey' ? 'lightgrey' : '' }" )  {{getNote(a.note)}}
                    v-divider.mt-2


            v-skeleton-loader(v-else type="list-item@10" )
</template>

<script lang="ts">
import {Component} from "vue-property-decorator";
import Vue from "vue";
import moment from "moment"
import {usePiniaStore} from "@/store/piniaStore";
import RatingStatistic from "@/model/RatingStatistic";
import {TranslateResult} from "@/i18n";
import RatingStatisticDetail from "@/model/RatingStatisticDetail";
import {RatingStatisticPayload} from "@/types/payload";

@Component({
  components: {
  }
})

export default class RatingStatisticsPage extends Vue {

  $refs!: {
    dateMenu: Vue & {
      save(date: string): void,
    },
  }

  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: TranslateResult = ''
  private fetchInProgress: boolean = false
  private selectedMonth: string | null = ''
  private dateMenu: boolean = false
  private tab: number = 0
  private piniaStore: any = usePiniaStore()
  private ratingStatistic: RatingStatistic | null = null
  private customer: any | null = null
  private idx: number = 0
  private ratingStatisticsDetail: RatingStatisticDetail[] = []
  private reportDate: string = ''

  getNoteColor(item: string): string {
    if (!item) {
      return 'grey'
    } else {
      return ''
    }
  }

  getFormattedDate(item: string): string {
    return moment(item).format('D.M.YYYY')
  }

  getNote(item: string): string {
    let note: string = ''
    if(item) {
      note = item
    } else {
      note = this.$t('ratingStatisticPage.withoutDescription').toString()
    }
    return note
  }

  getRatingColor(item: number): string {
    let color: string = ''
    if(item === 1){
      color = 'error'
    }
    if(item === 2){
      color = 'orange'
    }
    if(item === 3){
      color = 'primary'
    }
    if(item === 4){
      color = 'success'
    }
    return color
  }

  getRatingValue(item: number): string {
    let icon: string = ''
    if(item === 1){
      icon = 'fas fa-grimace'
    }
    if(item === 2){
      icon = 'fas fa-frown-open'
    }
    if(item === 3){
      icon = 'fas fa-smile'
    }
    if(item === 4){
      icon = 'fas fa-grin-hearts'
    }
    return icon
  }

  getValue(item:any, i:any) {
    if (typeof item !== 'number' || typeof i !== 'number' || i === 0) {
      return 0
    }
    return (item / i) * 100
  }

  getDate(item: string): string {
    return moment(item).format('DD.MM.YYYY')
  }


  get getCardClass (): string {
    let width: string = ''
    if(this.$vuetify.breakpoint.mdAndUp){
      width = '600px'
    } else {
      width = ''
    }
    return width
  }

  get getFormattedDetailData(): any {
    const groupedData:any = {}

    this.ratingStatisticsDetail!.forEach((item: RatingStatisticDetail) => {
      const date = item.date.split('T')[0]
      if (!groupedData[date]) {
        groupedData[date] = []
      }
      groupedData[date].push(item)
    })

    return groupedData
  }

  get getMonth(): string {
    return this.selectedMonth ? moment(this.selectedMonth).locale('sk').format('MMMM YYYY').toLocaleUpperCase() : moment().locale('sk').format('MMMM YYYY').toLocaleUpperCase()
  }

  onDateClick(): void {
    this.tab = 1
  }

  onNextButtonClick (): void {
    this.selectedMonth = moment(this.selectedMonth, 'YYYY-MM').add(1,'month').format('YYYY-MM')
    this.fetchRatingData()
    this.fetchRatingDetailData()
  }

  onPrevButtonClick (): void {
    this.selectedMonth = moment(this.selectedMonth, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
    this.fetchRatingData()
    this.fetchRatingDetailData()
  }

  onMonthChange (item: string) {
    this.selectedMonth = item
    this.fetchRatingData()
    this.fetchRatingDetailData()
  }

  async onSaveReportClick ():  Promise<any> {
    let momentDate = moment(this.selectedMonth, 'YYYY-MM')
    let dateFrom = momentDate.clone().startOf('month')
    let dateTo =  momentDate.clone().endOf('month')
    let dateFormat = 'YYYY-MM-DD'
    let dateFromString = dateFrom.format(dateFormat)
    let dateToString = dateTo.format(dateFormat)
    let customerId = this.customer[0].id
    this.reportDate = moment(dateFromString).format('YYYY-MM')
    const payload:RatingStatisticPayload = {
      customer: `/api/customer/${customerId}`,
      dateFrom: dateFromString,
      dateTo:  dateToString,
    }
    this.fetchInProgress = true
    try {
      const response = await this.piniaStore.fetchRatingPdfReport(payload)
      if(response) {
        const fileURL = window.URL.createObjectURL(new Blob([response]));
        const fileLink = document.createElement('a');
        fileLink.style.display = 'none'
        fileLink.href = fileURL
        let filename = this.reportDate + ` - report-hodnoteni.pdf`
        fileLink.setAttribute('download', filename)
        document.body.appendChild(fileLink)
        fileLink.click();
      }

      this.fetchInProgress = false
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('ratingStatisticPage.errorMessage')
    } finally {
    }
  }

  async fetchRatingData(): Promise<any> {
    let momentDate = moment(this.selectedMonth, 'YYYY-MM')
    let dateFrom = momentDate.clone().startOf('month')
    let dateTo =  momentDate.clone().endOf('month')
    let dateFormat = 'YYYY-MM-DD'
    let dateFromString = dateFrom.format(dateFormat)
    let dateToString = dateTo.format(dateFormat)
    let customerId = this.customer[0].id
      const payload:RatingStatisticPayload = {
        customer: `/api/customer/${customerId}`,
        dateFrom: dateFromString,
        dateTo:  dateToString,
      }
      this.fetchInProgress = true
      try {
        const response = await this.piniaStore.fetchRating(payload)
        this.ratingStatistic = response
        this.fetchInProgress = false
      } catch (e) {
        this.showSnackBar = true
        this.snackBarColor = 'error'
        this.snackBarMessage = this.$t('ratingStatisticPage.errorMessage')
      } finally {
      }
  }

  async fetchRatingDetailData(): Promise<any> {
    let momentDate = moment(this.selectedMonth, 'YYYY-MM')
    let dateFrom = momentDate.clone().startOf('month')
    let dateTo =  momentDate.clone().endOf('month')
    let dateFormat = 'YYYY-MM-DD'
    let dateFromString = dateFrom.format(dateFormat)
    let dateToString = dateTo.format(dateFormat)
    let customerId = this.customer[0].id
    const payload:RatingStatisticPayload = {
      customer: `/api/customer/${customerId}`,
      dateFrom: dateFromString,
      dateTo:  dateToString,
    }
    this.fetchInProgress = true
    try {
      const response = await this.piniaStore.fetchRatingDetail(payload)
      this.ratingStatisticsDetail = response
      this.fetchInProgress = false
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('ratingStatisticPage.errorMessage')
    } finally {
    }
  }

  async fetchCustomer(): Promise<void> {
    try {
      const response = await this.piniaStore.fetchCustomerData()
      this.customer = response.data
      if(this.customer){
        this.fetchRatingData()
        this.fetchRatingDetailData()
      }
    } catch (e) {
    } finally {
    }
  }


  mounted(): void {
    this.selectedMonth = moment().format('YYYY-MM')
    this.fetchCustomer()

  }
}
</script>

<style lang="stylus" scoped>
.text-style
  color black
.list-item-style
  cursor pointer
</style>
